import { i18n } from '../i18n';
import { renderTemplate } from '../template-engine';
import { buildTemplateData, formatters } from '../template-utils';

import traverseDetailsTpl from '../templates/traverse-details.html?raw';

const els = {
  traverseDetails: document.getElementById('traverse-details') as HTMLElement,
  traverseTitle: document.getElementById('traverse-title') as HTMLElement,
  traverseContent: document.getElementById('traverse-content') as HTMLElement,
};

export function renderTraversePanel(state: any): void {
  const t = state.selectedTraverse;
  if (!t) return;

  console.log('renderTraversePanel with ', t);

  els.traverseDetails.style.display = 'block';
  els.traverseTitle.textContent = i18n.t('traverse.title_prefix');

        const templateData = buildTemplateData(
          t,
          {
            name: { key: 'num', fallback: i18n.t('ui.unnamed') },
            expName: { key: 'expedition.name', fallback: i18n.t('ui.unknown') },
            vesselName: { key: 'vessel.name', fallback: i18n.t('ui.unknown') },
            dateStart: { key: 'date_start', format: formatters.date },
            dateEnd: { key: 'date_end', format: formatters.date, fallback: i18n.t('ui.not_specified') },
            descriptionHtml: { key: 'description', format: formatters.html, fallback: null },
//    obs_ount: { key: 'points', format: () => (t.points ? t.points : '-'), fallback: i18n.t('ui.not_specified') },
    obs_count: { key: 'points', fallback: i18n.t('ui.not_specified') },
    smp_count: { key: 'samples', fallback: i18n.t('ui.not_specified') },
    length: { key: 'length', fallback: i18n.t('ui.not_specified') },
          },
          {
            i18n: {
              traverse: {
                expedition: i18n.t('traverse.expedition'),
                vessel: i18n.t('traverse.vessel'),
                date_start: i18n.t('traverse.date_start'),
                date_end: i18n.t('traverse.date_end'),
                description: i18n.t('traverse.description'),
        obs_count: i18n.t('traverse.obs_count'),
        smp_count: i18n.t('traverse.smp_count'),
        length: i18n.t('traverse.length')
              }
            }
          }
        );


  console.log('render data is ', templateData);

  els.traverseContent.innerHTML = renderTemplate(traverseDetailsTpl, templateData);
}

export function hideTraversePanel(): void {
  els.traverseDetails.style.display = 'none';
}